<template>
  <div :style="customStyle" class="sedna-slider-app" :class="{ aretv: isAretv }">
      <h1 v-if="isEmptyAndLoading">Loading...</h1>
      <h1 class="news" v-if="title!==null && title !==''"><span>{{title}}</span>&nbsp;<span class="news-bar"></span>
      </h1>
      <Slider :items="entries" v-if="!isEmptyAndLoading"/>
  </div>
</template>

<script>
  import {format} from "date-fns";
  import Slider from './Slider'
  import Parser from 'rss-parser'


  export default {
    name: 'RssFeeds',
    components: { Slider },
    props: { 
      customStyle: { type: Object, default: () => {} },
      customColor: { type: String, default: '' },
      customBackground: { type: String, default: '' },
      isAretv: { type: Boolean, default: true }
    },
    data: function () {
      return {
        isLoading: false,
        entries: [],
        refreshTimer: null,
        title: null
      }
    },
    computed: {
      isEmptyAndLoading() {
        return this.isLoading && this.entries.length === 0
      }
    },
    methods: {
      refreshFeeds() {
        // Roll with defaults
        const CORS_PROXY_URL = 'https://cors-proxy.advent.zone/'
        const parser = new Parser()
        let urls = [
          'https://feeds.a.dj.com/rss/RSSOpinion.xml',
          'https://feeds.a.dj.com/rss/RSSWorldNews.xml',
          'https://feeds.a.dj.com/rss/WSJcomUSBusiness.xml',
          'https://feeds.a.dj.com/rss/RSSMarketsMain.xml',
          'https://feeds.a.dj.com/rss/RSSWSJD.xml',
          'https://feeds.a.dj.com/rss/RSSLifestyle.xml',
        ]

        // ...unless some URLs are provided from the outside
        const urlQuery = new URLSearchParams(window.location.search)
        if (urlQuery.get("feeds") !== null) {
          urls = urlQuery.get("feeds").split(",")
        }

        // Handle title
        if (urlQuery.get("title") !== null) {
          this.title = urlQuery.get("title")
        }

        // eslint-disable-next-line
        console.log("Feed URLs:")
        // eslint-disable-next-line
        console.table(urls)

        const parsers = urls.map(url => parser.parseURL(CORS_PROXY_URL + url))

        this.isLoading = true

        Promise.all(parsers)
          .then(fetchedFeeds => {
            // for each downloaded feed
            this.entries = fetchedFeeds.reduce((entries, feedData) => {
              // for each feed item
              const feedItems = feedData.items.map(item => {
                return {
                  // add source title and formatted timestamp
                  ...item,
                  sourceTitle: feedData.title,
                  timestamp: format(new Date(item.pubDate), 'MMMM do')
                }
              })
              return entries.concat(feedItems)
            }, [])
            this.isLoading = false
          })
      }
    },
    created() {
      this.refreshFeeds()
      this.refreshTimer = setInterval(this.refreshFeeds, 30 * 60 * 1000)  // refresh news every 30 mins
    }
  }
</script>

<style>
    .news .news-bar {
        width: 100px;
        height: 5px;
        background-color: white;
        margin-left: 25px;
        border-radius: 25px;
        align-self: center;
    }

    .sedna-slider-app h1 {
        margin: 0;
        font-size: 64px;
        line-height: 64px;
        text-transform: uppercase;
        font-family: 'Avenir Next LT Pro', Helvetica, sans-serif;
    }

    .sedna-slider-app h2 {
        margin: 0 0 20px 0;
        font-size: 50px;
        line-height: 60px;
        font-weight: normal;
        font-family: 'Avenir Next LT Pro', Helvetica, sans-serif;
    }

    .sedna-slider-app.aretv h1 {
        font-size: 78px;
        line-height: 78px;
    }

    .sedna-slider-app.aretv h2 {
        font-size: 78px;
        line-height: 78px;
    }
</style>
